import { DidomiSDK } from '@didomi/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { registerConsent } from '../../store/cmp/cmpSlice.js'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import CMPService from './CMPService'
import { DIDOMI_API_KEY, DIDOMI_NOTICE_ID } from './cmp.constants.js'

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(function CMPPlaceholder() {
  const dispatch = useDispatch()

  return (
    <DidomiSDK
      iabVersion={2}
      apiKey={DIDOMI_API_KEY}
      noticeId={DIDOMI_NOTICE_ID}
      sdkPath="//privacy.mappy.com/"
      onReady={didomiSDK => {
        CMPService.setSDK(didomiSDK)
        dispatch(registerConsent(CMPService.getConsents()))
        CMPService.onCmpReady()
      }}
      onConsentChanged={() => {
        dispatch(registerConsent(CMPService.getConsents()))
        CMPService.onConsentChanged()
      }}
    />
  )
})
